<template>
	<inertia-head title="Gold Call" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Gold Call</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Live and Replays of the Gold Call exclusive to Truly Rich Club
						Members.
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div v-if="user.current_rank === 'SILVER'" class="content">
		<div class="alert alert-warning">
			<p class="mb-0 fw-semibold">
				UPGRADE to GOLD or HIGHER to view GOLD CALL
			</p>
		</div>
	</div>
	<div v-else class="content mt-5">
		<div v-if="selectedGoldCall" class="col-lg-8 m-auto">
			<SelectedGoldCall :gold-call="selectedGoldCall" :comments="comments" />
		</div>
		<div v-else>
			<div v-if="featuredGoldCall" class="block block-rounded">
				<div class="block-header border-bottom">
					<h3 class="block-title">{{ featuredGoldCall.title }}</h3>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div class="col-md-8 h-100">
							<VimeoIframe :videoId="featuredGoldCall.video_id">
								<InertiaLink
									:href="
										route('member.my-materials.gold-call', {
											v: featuredGoldCall.video_id,
										})
									"
									class="btn btn-alt-secondary rounded-0 position-relative"
								>
									<i class="fa fa-external-link-alt"></i>
								</InertiaLink>
							</VimeoIframe>
						</div>
						<div class="col-md-4 h-100">
							<VimeoIframe
								:video-link="`https://vimeo.com/live-chat/${featuredGoldCall.video_id}`"
							/>
						</div>
					</div>
				</div>
			</div>
			<div v-if="upComingGoldCalls && upComingGoldCalls.length > 0" class="block">
				<div class="block-header border-bottom">
					<h3 class="block-title">Upcoming Gold Calls</h3>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div
							v-for="upComingGoldCall in upComingGoldCalls"
							:key="upComingGoldCall.video_id"
							class="col-xl-4 col-lg-6 col-md-6 mb-4"
						>
							<VimeoIframe :video-id="upComingGoldCall.video_id">
								<InertiaLink
									:href="
										route('member.my-materials.gold-call', {
											v: upComingGoldCall.video_id,
										})
									"
									class="btn btn-alt-secondary rounded-0 position-relative"
								>
									<i class="fa fa-external-link-alt"></i>
								</InertiaLink>
							</VimeoIframe>
						</div>
					</div>
				</div>
			</div>
			<div v-if="pastGoldCalls && pastGoldCalls.length > 0" class="block">
				<div class="block-header border-bottom">
					<h3 class="block-title">Past Gold Calls</h3>
				</div>
				<div class="block-content block-content-full">
					<div class="row">
						<div
							v-for="pastGoldCall in pastGoldCalls"
							:key="pastGoldCall.video_id"
							class="col-xl-4 col-lg-6 col-md-6 mb-4"
						>
							<VimeoIframe :video-id="pastGoldCall.video_id">
								<InertiaLink
									:href="
										route('member.my-materials.gold-call', {
											v: pastGoldCall.video_id,
										})
									"
									class="btn btn-alt-secondary rounded-0 position-relative"
								>
									<i class="fa fa-external-link-alt"></i>
								</InertiaLink>
							</VimeoIframe>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!selectedGoldCall && !featuredGoldCall && upComingGoldCalls.length<=0 && pastGoldCalls<=0" class="text-center h1 mt-5">
			<p class="pt-5">NO VIDEO FOUND</p>
		</div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue';
import SelectedGoldCall from './SelectedGoldCall';

defineProps({
	user: Object,
	selectedGoldCall: Object,
	featuredGoldCall: Object,
	upComingGoldCalls: Object,
	pastGoldCalls: Object,
	comments: Object,
})

onMounted(() => {
	const pageContainer = document.getElementById('page-container')
	if (pageContainer.classList.contains('sidebar-o-xs'))
		pageContainer.classList.remove('sidebar-o-xs')
})
</script>

<script>
import AuthLayout from '../../../../Layouts/AuthLayout'
export default { layout: AuthLayout }
</script>
